import React from 'react'

import PropTypes from 'prop-types'

import './footer.css'

const Footer = (props) => {
  return (
    <div className={`footer-container Fade_in_up1 ${props.rootClassName} `}>
      <div className="footer-container1">
        <div className="footer-social-icons">
          <a
            href="https://www.linkedin.com/in/bharat-karade-ab92a368/"
            target="_blank"
            rel="noreferrer noopener"
            className="footer-link"
          >
            <div className="footer-icon Cursor">
              <svg viewBox="0 0 1024 1024" className="footer-icon01">
                <path
                  d="M384 384h177.106v90.782h2.532c24.64-44.194 84.958-90.782 174.842-90.782 186.946 0 221.52 116.376 221.52 267.734v308.266h-184.61v-273.278c0-65.184-1.334-149.026-96.028-149.026-96.148 0-110.82 70.986-110.82 144.292v278.012h-184.542v-576z"
                  className=""
                ></path>
                <path d="M64 384h192v576h-192v-576z" className=""></path>
                <path
                  d="M256 224c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"
                  className=""
                ></path>
              </svg>
            </div>
          </a>
          <a
            href="mailto:bk.1589@gmail.com?subject=Hey There,"
            className="footer-link1"
          >
            <div className="footer-icon05 Cursor">
              <svg viewBox="0 0 1024 1024" className="footer-icon06">
                <path
                  d="M512 470l342-214h-684zM854 768v-426l-342 212-342-212v426h684zM854 170q34 0 59 26t25 60v512q0 34-25 60t-59 26h-684q-34 0-59-26t-25-60v-512q0-34 25-60t59-26h684z"
                  className=""
                ></path>
              </svg>
            </div>
          </a>
          <a href="tel:+91 74151 32302" className="footer-link2">
            <div className="footer-icon08 Cursor">
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="footer-icon09"
              >
                <path
                  d="M562.857 556.571c9.714 0 102.857 48.571 106.857 55.429 1.143 2.857 1.143 6.286 1.143 8.571 0 14.286-4.571 30.286-9.714 43.429-13.143 32-66.286 52.571-98.857 52.571-27.429 0-84-24-108.571-35.429-81.714-37.143-132.571-100.571-181.714-173.143-21.714-32-41.143-71.429-40.571-110.857v-4.571c1.143-37.714 14.857-64.571 42.286-90.286 8.571-8 17.714-12.571 29.714-12.571 6.857 0 13.714 1.714 21.143 1.714 15.429 0 18.286 4.571 24 19.429 4 9.714 33.143 87.429 33.143 93.143 0 21.714-39.429 46.286-39.429 59.429 0 2.857 1.143 5.714 2.857 8.571 12.571 26.857 36.571 57.714 58.286 78.286 26.286 25.143 54.286 41.714 86.286 57.714 4 2.286 8 4 12.571 4 17.143 0 45.714-55.429 60.571-55.429zM446.857 859.429c197.714 0 358.857-161.143 358.857-358.857s-161.143-358.857-358.857-358.857-358.857 161.143-358.857 358.857c0 75.429 24 149.143 68.571 210.286l-45.143 133.143 138.286-44c58.286 38.286 127.429 59.429 197.143 59.429zM446.857 69.714c237.714 0 430.857 193.143 430.857 430.857s-193.143 430.857-430.857 430.857c-72.571 0-144.571-18.286-208.571-53.714l-238.286 76.571 77.714-231.429c-40.571-66.857-61.714-144-61.714-222.286 0-237.714 193.143-430.857 430.857-430.857z"
                  className=""
                ></path>
              </svg>
            </div>
          </a>
        </div>
        <div className="footer-name"></div>
        <div className="footer-creator-tag">
          <a
            href="https://twitter.com/DeltZx"
            target="_blank"
            rel="noreferrer noopener"
            className="footer-link3"
          >
            {props.CreatorTag}
          </a>
        </div>
      </div>
    </div>
  )
}

Footer.defaultProps = {
  rootClassName: '',
  CreatorTag: 'Custom Design by ZxDelt',
}

Footer.propTypes = {
  rootClassName: PropTypes.string,
  CreatorTag: PropTypes.string,
}

export default Footer
